export const global = {
  login_admin: '/portal/admin/dashboard',
  login_pccwglobal_sales: '/portal/pccwglobal_sales/dashboard',
  login_pccwglobal_product: '/portal/pccwglobal_product/dashboard',
  login_master: '/portal/customer/master/dashboard',
  login_sub_account_sales: '/portal/customer/sub_account_sales/dashboard',
  login_sub_account_product: '/portal/customer/sub_account_product/dashboard',
  login_sub_account_billing: '/portal/customer/sub_account_billing/dashboard',
  login_sub_account_operation: '/portal/customer/sub_account_operation/dashboard',
  login_registered: '/portal/registered/dashboard',
  login_visitor: '/portal/visitor',
  logout: '/account/login',
  unauthorised: '/portal/unauthorised',
  notfound: '/portal/404',
  PAGE: 0,
  LIMIT: 10
};
